// extracted by mini-css-extract-plugin
export default {"moreCount":"moreCount---mEuO_","list":"list---GPRnP","type":"type---JBLql"};